<template>
    <div>
        <b-modal id="verification_reason_modal" title="Verification reason">
            <div slot="modal-header" class="mh">
                <div>
                    <h1>
                        <span>Verification reason</span>
                    </h1>
                </div>
                <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
            </div>

            <div class="modal-body">
                <label class="form-label" for="description">
                    Please explain why you manually verify the worker.
                </label>
                <textarea v-model="text" class="form-input requiredField"></textarea>
                <span class="text-danger">{{ error }}</span>
            </div>

            <template v-slot:modal-footer="{ cancel, ok }">
                <button v-if="processing === false" type="button" class="btn orcaBtn" @click="onOk()">Verify</button>
                <button v-else type="button" class="btn orcaBtn disabled">Verifying...</button>
            </template>

        </b-modal>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    props: ['worker_id'],
    data() {
        return {
            text: null,
            processing: false,
            error: null
        };
    },
    methods: {
        onOk() {

            if (!this.text) {
                this.error = 'Please provide the reason.';
                return;
            }

            this.processing = true;
            let payload = { worker_id: this.worker_id, verification_reason: this.text }
            const path = (this.crmApiPath || '') + 'worker/verify_web_account';
            axios.post(path, payload).then((verified) => {
                this.$root.$emit('worker_account_verified', verified.data.data);
                this.$bvModal.hide('verification_reason_modal');
                this.processing = false;
                this.$snotify.success('Worker web account verified succesfully!');
            }).catch((verified) => {
                let error = 'Something went wrong. Please contact IT department.';
                if(verified.response && verified.response.data) {
                    error = verified.response.data.error;
                }
                this.processing = false;
                this.$snotify.error(error);
            });
        },
        hideModal() {
            this.$root.$emit('worker_account_verifying', false);
            this.$bvModal.hide('verification_reason_modal');
        },
    },
    mounted() {
        this.$root.$on('bv::show::modal', ($event) => {
            this.$root.$emit('worker_account_verifying', true);
        });
    },
};
</script>
